var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIonicIosSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19.005,
    viewBox: "0 0 19 19.005",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-settings",
    "data-name": "Icon ionic-ios-settings",
    d: "M21.932,14A2.445,2.445,0,0,1,23.5,11.719a9.691,9.691,0,0,0-1.173-2.825,2.478,2.478,0,0,1-.995.213A2.44,2.44,0,0,1,19.1,5.673,9.662,9.662,0,0,0,16.281,4.5a2.443,2.443,0,0,1-4.562,0A9.691,9.691,0,0,0,8.894,5.673,2.44,2.44,0,0,1,6.662,9.107a2.4,2.4,0,0,1-.995-.213A9.9,9.9,0,0,0,4.5,11.724a2.444,2.444,0,0,1,0,4.562,9.691,9.691,0,0,0,1.173,2.825A2.441,2.441,0,0,1,8.9,22.332,9.748,9.748,0,0,0,11.724,23.5a2.438,2.438,0,0,1,4.552,0A9.691,9.691,0,0,0,19.1,22.332a2.443,2.443,0,0,1,3.221-3.221A9.748,9.748,0,0,0,23.5,16.286,2.457,2.457,0,0,1,21.932,14Zm-7.887,3.953A3.958,3.958,0,1,1,18,14,3.957,3.957,0,0,1,14.045,17.953Z",
    transform: "translate(-4.5 -4.5)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIonicIosSettings);
export default __webpack_public_path__ + "static/media/ionic-ios-settings.7e9f86e9bc3d4b342e6cdefc82172e6b.svg";
export { ForwardRef as ReactComponent };